import { ref, watch, computed } from "@vue/composition-api";
import store from "@/store";
import { title } from "@core/utils/filter";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ability from "@/libs/acl/ability";

export default function useWorksList() {
  //User toast
  const toast = useToast();

  const refWorkListTable = ref(null);

  const tableColumns = [
    { key: "id", stickyColumn: true, sortable: true },
    { key: "title", label: "標題", sortable: true },
    { key: "remark", label: "備註", sortable: true },
    { key: "work_date", label: "日期", sortable: true },
    { key: "time_from", label: "上班時間" },
    { key: "time_to", label: "下班時間" },
    { key: "admin_remark", label: "管理員備註" },
    { key: "approve_bit", label: "已批核" },
    { key: "action", label: "操作" },
  ];

  const perPage = ref(10);
  const totalWorks = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("id");
  const isSortDirDesc = ref(true);

  const dataMeta = computed(() => {
    const localItemsCount = refWorkListTable.value
      ? refWorkListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalWorks.value,
    };
  });

  const refetchData = () => {
    refWorkListTable.value.refresh();
  };

  watch([currentPage, perPage, searchQuery], () => {
    refetchData();
  });

  const fetchWorks = (ctx, callback) => {
    store
      .dispatch("admin-work/fetchWorks", {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        is_personal: true,
      })
      .then((response) => {
        const { works, total } = response.data;
        callback(works);
        totalWorks.value = total;
      })
      .catch((error) => {
        toast({
          component: ToastificationContent,
          props: {
            title: "Error fetching work list",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  return {
    fetchWorks,
    tableColumns,
    perPage,
    currentPage,
    totalWorks,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refWorkListTable,
    ability,
    refetchData,
  };
}
